var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview _fixed _overlay _bg-white _text-black _flex _items-center _justify-center"},[_vm._v("Loading Preview...")])}
var staticRenderFns = []

export { render, staticRenderFns }